let count = 0;
// let savedScrollY = 0;
let prevOverflow: string | null = null;
let prevPaddingRight: string | null = null;

export function lockScroll() {
  try {
    count += 1;
    if (count === 1) {
        prevOverflow = document.body.style.overflow ?? null;
        prevPaddingRight = document.body.style.paddingRight ?? null;
        try {
          const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
          if (scrollbarWidth > 0) {
            document.body.style.paddingRight = `${scrollbarWidth}px`;
          }
          document.body.style.overflow = 'hidden';
          try {
            const wrapper = document.getElementById('modal-container');
            if (wrapper) wrapper.setAttribute('data-cc-overlay-active', 'true');
          } catch (e) {
            // ignore
          }
        } catch (e) {
          // ignore
        }
    }
  } catch (err) {
    // ignore
  }
}

export function unlockScroll() {
  try {
    count = Math.max(0, count - 1);
    if (count === 0) {
      document.body.style.overflow = prevOverflow ?? '';
      document.body.style.paddingRight = prevPaddingRight ?? '';
      // prevOverflow / padding reset done above - no scroll restore here
      prevOverflow = null;
      prevPaddingRight = null;
      // savedScrollY = 0;
      try {
        const wrapper = document.getElementById('modal-container');
        if (wrapper) wrapper.removeAttribute('data-cc-overlay-active');
      } catch (e) {
        // ignore
      }
    }
  } catch (err) {
    // ignore
  }
}

export function getLockCount() {
  return count;
}

